<template>
  <li>
    <div v-if="entity.type === 'HASHTAG'">
      <div class="wt-inst-logo hashtag">
        <i class="wticon wticon-instagram-hashtag"></i>
      </div>
      <div class="wt-inst-title-and-subtitle">
        <div class="wt-inst-title">{{ entity.name }}</div>
        <div class="wt-inst-subtitle wt2-color-disabled">
          {{ entity.count | formatNumber }} posts
        </div>
      </div>
    </div>
    <div v-if="entity.type === 'USERNAME'">
      <div class="wt-inst-logo user">
        <img :src="mixinProxySrc(entity.photo)" />
      </div>
      <div class="wt-inst-title-and-subtitle">
        <div class="wt-inst-title">
          {{ entity.name }}
          <img
            v-if="entity.verified"
            class="wt-inst-verified"
            src="/resources/img/instagram_verified.png"
          />
        </div>
        <div class="wt-inst-subtitle wt2-color-disabled">
          {{ entity.username }}
        </div>
      </div>
    </div>
    <div v-if="entity.type === 'PLACE'">
      <div class="wt-inst-logo place">
        <i class="wticon wticon-instagram-location"></i>
      </div>
      <div class="wt-inst-title-and-subtitle">
        <div class="wt-inst-title">{{ entity.name }}</div>
        <div class="wt-inst-subtitle wt2-color-disabled">
          {{ entity.subtitle }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  filters: {
    formatNumber: function (v) {
      return v.toLocaleString();
    },
  },
};
</script>

<style></style>
